// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class TenantSiteSiteSearchSiteSearchResponseData {
    static getAttributeTypeMap() {
        return TenantSiteSiteSearchSiteSearchResponseData.attributeTypeMap;
    }
}
TenantSiteSiteSearchSiteSearchResponseData.discriminator = undefined;
TenantSiteSiteSearchSiteSearchResponseData.additionalProperties = false;
TenantSiteSiteSearchSiteSearchResponseData.attributeTypeMap = [
    {
        "name": "sites",
        "baseName": "sites",
        "type": ""
    },
];
//# sourceMappingURL=tenantSiteSiteSearchSiteSearchResponseData.js.map